import { useState, useEffect } from "react";
import { useParams } from "react-router-dom"; // or next/router if using Next.js
import axios from "../config/axios";
import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import DetailsComponent from "../components/recipesPartials/DetailsComponent";
import FullScreenLoading from "../components/common/loading/FullScreenLoading";
import ApiErrorMessage from "../components/common/ApiErrorMessage";
import { useGeneral } from "../components/contexts/GeneralContext";
import NoItemsFound from "../components/common/NoItemsFound";

const RecipesDetailsPage = () => {
  const { id } = useParams(); // fetch the recipe id from URL params
  const { discountCoupons } = useGeneral();

  const [recipe, setRecipe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!id) return;

    let active = true;
    setLoading(true);

    (async () => {
      try {
        const { data } = await axios.get(`/recipes/${id}`);
        if (active) setRecipe(data);
      } catch (err) {
        console.error(err);
        if (active) setError("Failed to load recipe. Please try again later.");
      } finally {
        if (active) setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, [id]);

  return (
    <>
      {loading && <FullScreenLoading />}
      <PageWrapper loading={loading} className="">
        <Header code={discountCoupons} />
        <BodyWrapper loading={loading} className="">
          {!loading && error ? (
            <ApiErrorMessage
              message1="Failed to load recipe"
              message2="Please check your connection and try again."
            />
          ) : !loading && !recipe ? (
            <NoItemsFound
              message1="No recipe available"
              message2="Please check back later."
            />
          ) : (
            <div className="grid grid-cols-1">
              <DetailsComponent recipe={recipe} />
            </div>
          )}
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default RecipesDetailsPage;
